import PropTypes from 'prop-types';
import classes from './loanSummaryCard.module.css';

const DataSummaryCard = ({ details }) => (
  <div className={classes.summaryCard}>
    {details
      .filter((item) => item.value !== null && item.value !== undefined && item.value !== '')
      .map((item, index) => (
        <div key={item.label} className={classes.summarySection}>
          <div className={classes.summaryLabel}>{item.label}</div>
          <div className={classes.summaryValue} style={{ color: item.color }} >{item.value}</div>
          {index > 0 && <div className={classes.summaryDivider} />}
        </div>
      ))}
  </div>
);

DataSummaryCard.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
};

export default DataSummaryCard;
